<template lang="pug">
.message-container(:class="baseMessage")
  .message-bubble
    .message-bubble_header
      .message-bubble_name
        i(v-if="senderType === 'customers'",
          :title="channelInfoTitle",
          :class="`aiq-ico-conversation-${channel}`")
        i(v-if="senderType === 'agents'",
          :title="channelInfo.title",
          :class="`aiq-ico-conversation-${channel}-white`")
        span {{ senderName }}
      .message-bubble_date
        aiq-timeago(:since="messageDate" :maxTime="maxTime")
    .message-bubble_content(v-html="urlFilter(content)")
</template>

<script>
import get from 'lodash/get';

export default {
  props: {
    message: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      senderName: get(this.message, 'senderName', ''),
      channel: this.message.channel,
      channelInfoTitle: get(this.message, 'channelInfo.title', ''),
      senderType: get(this.message, 'message.sender_info', ''),
      content: this.$filters.sanitize(get(this.message, 'content', '')),
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
